export default "/images/92cd894a789fbb74fe216e749728dcf6.avif";